(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["regrip-dispatch"] && !Shopify.designMode) return;
  try {
    (() => {
    const zone = 'Australia/Sydney';
    const formatter = new Intl.DateTimeFormat('en-AU', {
      timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    function dispatchState(now, closures, until) {
      const p = Object.fromEntries(formatter.formatToParts(now).map(part => [part.type, part.value]));
      const date = new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day)));
      const key = d => d.toISOString().slice(0, 10);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(until) || key(date) > until) return { kind: 'fallback' };
      const open = d => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !closures.has(key(d));
      const seconds = 14 * 3600 - Number(p.hour) * 3600 - Number(p.minute) * 60 - Number(p.second);
      if (open(date) && seconds > 0) {
        const mins = Math.ceil(seconds / 60);
        return { kind: 'today', time: mins >= 60 ? Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm' : mins + 'm' };
      }
      for (let offset = 1; offset <= 370; offset++) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (key(date) > until) return { kind: 'fallback' };
        if (open(date)) {
          const day = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'short' }).format(date);
          return { kind: 'next', day, date: key(date) };
        }
      }
      return { kind: 'fallback' };
    }
    class RegripDispatch extends HTMLElement {
      connectedCallback() {
        this.message = this.querySelector('[data-dispatch-message]');
        this.details = this.querySelector('[data-dispatch-details]');
        this.summary = this.closest('.product-summary');
        this.eligible = new Set((this.dataset.eligibleIds || '').split(',').filter(Boolean));
        this.closures = new Set((this.dataset.closedDates || '').split(/[\s,]+/).filter(Boolean));
        this.refresh = () => {
          const form = this.summary?.querySelector('[data-type="add-to-cart-form"]');
          const selected = form?.querySelector('[name="id"]')?.value || this.dataset.initialId;
          this.hidden = this.dataset.scope !== 'store' && (!this.eligible.has(String(selected)) || Boolean(form?.classList.contains('disabled')));
          if (this.hidden || !this.message) return;
          const state = dispatchState(new Date(), this.closures, this.dataset.calendarUntil || '');
          const message = state.kind === 'today' ? this.dataset.today.replace('__TIME__', state.time)
            : state.kind === 'next' ? this.dataset.next.replace('__DAY__', state.day) : this.dataset.fallback;
          if (this.message.textContent !== message) this.message.textContent = message;
          this.details.hidden = this.dataset.scope === 'store' || state.kind === 'fallback';
        };
        this.changed = () => queueMicrotask(this.refresh);
        this.summary?.addEventListener('change', this.changed);
        document.addEventListener('product-variant-updated', this.changed);
        document.addEventListener('visibilitychange', this.refresh);
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
        this.timer = setInterval(this.refresh, 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.summary?.removeEventListener('change', this.changed);
        document.removeEventListener('product-variant-updated', this.changed);
        document.removeEventListener('visibilitychange', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }
    }
    if (!customElements.get('regrip-dispatch')) customElements.define('regrip-dispatch', RegripDispatch);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["regrip-low-stock"] && !Shopify.designMode) return;
  try {
    (() => {
    class RegripLowStock extends HTMLElement {
      connectedCallback() {
        this.summary = this.closest('.product-summary');
        this.message = this.querySelector('[data-stock-message]');
        this.stock = new Map((this.dataset.stock || '').split(',').filter(Boolean).map(item => item.split(':')));
        this.refresh = () => {
          const form = this.summary?.querySelector('[data-type="add-to-cart-form"]');
          const selected = form?.querySelector('[name="id"]')?.value || this.dataset.initialId;
          const quantity = this.stock.get(String(selected));
          this.hidden = !quantity || Boolean(form?.classList.contains('disabled'));
          const text = this.hidden ? '' : this.dataset.copy.replace('__COUNT__', quantity);
          if (this.message && this.message.textContent !== text) this.message.textContent = text;
        };
        this.changed = () => queueMicrotask(this.refresh);
        this.summary?.addEventListener('change', this.changed);
        document.addEventListener('product-variant-updated', this.changed);
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }
      disconnectedCallback() {
        this.summary?.removeEventListener('change', this.changed);
        document.removeEventListener('product-variant-updated', this.changed);
        window.removeEventListener('pageshow', this.refresh);
      }
    }
    if (!customElements.get('regrip-low-stock')) customElements.define('regrip-low-stock', RegripLowStock);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["regrip-restock-notify"] && !Shopify.designMode) return;
  try {
    (() => {
    class RegripRestock extends HTMLElement {
      connectedCallback() {
        this.summary = this.closest('.product-summary');
        this.variants = new Map((this.dataset.variants || '').split(',').filter(Boolean).map(item => {
          const [id, available, title] = item.split(':');
          return [id, { available: available === '1', title }];
        }));
        this.refresh = () => {
          if (this.dataset.posted === 'true') return;
          const form = this.summary?.querySelector('[data-type="add-to-cart-form"]');
          const selected = form?.querySelector('[name="id"]')?.value;
          const variant = this.variants.get(String(selected));
          if (!variant) return;
          this.hidden = variant.available;
          const tags = this.querySelector('[data-restock-tags]');
          if (tags && this.dataset.default !== 'true') {
            tags.value = `restock, restock-${this.dataset.handle}, restock-${this.dataset.handle}--${variant.title}`;
          }
        };
        this.changed = () => setTimeout(this.refresh, 0);
        this.summary?.addEventListener('change', this.changed);
        document.addEventListener('product-variant-updated', this.changed);
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }
      disconnectedCallback() {
        this.summary?.removeEventListener('change', this.changed);
        document.removeEventListener('product-variant-updated', this.changed);
        window.removeEventListener('pageshow', this.refresh);
      }
    }
    if (!customElements.get('regrip-restock')) customElements.define('regrip-restock', RegripRestock);
  })();
  } catch(e) { console.error(e); }
})();

})();
